module.exports = __webpack_public_path__ + "media/67_BL.20b9fbe9.mp3";